import React from 'react';
import Image from 'gatsby-image';
import injectSheet from 'react-jss';

import { Block, Row } from '../common';
import theme from '../../theme';

const styles = {
  thumbnailsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.margins.medium,
  },
};

const ImagePicker = ({ classes, thumbnails, selectedImage, onSelectImage }) => (
  <Block style={{ justifyContent: 'center' }}>
    <Block>
      <Block>
        <Image critical key={selectedImage.id} fluid={selectedImage.fullSize} />
      </Block>
      <Row noExpand wrap className={classes.thumbnailsContainer}>
        {thumbnails.map(image => (
          <div key={image.id} onClick={() => onSelectImage(image)}>
            <Image fixed={image.thumbnail} />
          </div>
        ))}
      </Row>
    </Block>
    <Block
      noExpand
      style={{ alignItems: 'center' }}
      dangerouslySetInnerHTML={{
        __html: selectedImage.descriptionHtml,
      }}
    />
  </Block>
);

export default injectSheet(styles)(ImagePicker);
